export default "__VITE_ASSET__DgM8kiZp__"